// ── PARENT: FAMILY ───────────────────────────────────────────────────
// esc/calcAge (shared classic scripts) stay as bare globals — not migrated
// yet. editMyContact wired via VIEW_INIT (phase 2 of the onclick →
// addEventListener migration); saveParent is attached directly inside
// editMyContact() itself since it already controls the modal DOM it just
// wrote via openModal (same pattern as billing-shared.js's cardModal).
import { DB, session, PROGRAMS, US_STATES } from '../core/state.js';
import { kidPrograms, isValidEmail, formatAddress } from '../core/domain-utils.js';
import { apiFetch } from '../core/api.js';
import { openModal, closeModal, toast, toastError } from '../core/ui.js';
import { VIEWS, VIEW_INIT, refresh } from '../core/routing.js';
import { programPill } from './admin-registrations.js';

VIEWS['p-family'] = () => {
  const kids = DB.children.filter(c => c.accountId === session.id);
  return `
    <div class="page-head">
      <h2 class="serif">My <em>Family</em></h2>
    </div>
    <div style="max-width:600px;display:flex;flex-direction:column;gap:18px">
      <div class="card">
        <div class="card-hd">Parent / Guardian <button class="btn-ghost btn-sm" data-action="edit-contact">Edit</button></div>
        <div style="display:grid;grid-template-columns:1fr 1fr;gap:12px 24px">
          <div><div class="detail-label">Name</div><div style="font-size:14px;color:var(--cream)">${esc(session.firstName)} ${esc(session.lastName)}</div></div>
          <div><div class="detail-label">Email</div><div style="font-size:14px;color:var(--cream)">${esc(session.email)}</div></div>
          <div><div class="detail-label">Phone</div><div style="font-size:14px;color:var(--cream)">${esc(session.phone) || '—'}</div></div>
          <div style="grid-column:1 / -1"><div class="detail-label">Address</div><div style="font-size:14px;color:var(--cream);white-space:pre-line">${formatAddress(session) ? esc(formatAddress(session)) : '—'}</div></div>
        </div>
      </div>
      <div class="card">
        <div class="card-hd">Performers</div>
        ${kids.length ? kids.map((k, i) => { const ps = kidPrograms(k).map(id => PROGRAMS.find(p => p.id===id)).filter(Boolean); return `
          <div style="padding:12px 0;${i < kids.length - 1 ? 'border-bottom:1px solid var(--border-soft)' : ''}">
            <div style="display:flex;align-items:center;gap:10px;flex-wrap:wrap">
              <span style="font-size:14px;color:var(--cream)">${esc(k.name)}</span>
              <span style="font-size:12px;color:var(--muted)">Age ${calcAge(k.dob)}</span>
              ${ps.length ? ps.map(p => programPill(p.id)).join('') : '<span style="font-size:12px;color:var(--muted)">No program assigned</span>'}
            </div>
          </div>`; }).join('') : '<p class="empty">No performers on this account yet. Contact us to get enrolled.</p>'}
      </div>
    </div>`;
};

VIEW_INIT['p-family'] = () => {
  document.querySelectorAll('[data-action="edit-contact"]').forEach(btn => {
    btn.addEventListener('click', editMyContact);
  });
};

function editMyContact() {
  openModal(`
    <h3>Edit contact details</h3>
    <div class="field-row">
      <div class="field"><label>First name</label><input type="text" id="pfFirst" value="${esc(session.firstName)}"></div>
      <div class="field"><label>Last name</label><input type="text" id="pfLast" value="${esc(session.lastName)}"></div>
    </div>
    <div class="field"><label>Email</label><input type="email" id="pfEmail" value="${esc(session.email)}">
      <span id="pfEmailErr" style="display:none;font-size:12px;color:var(--red);margin-top:4px">Please enter a valid email address.</span></div>
    <div class="field"><label>Phone</label><input type="tel" id="pfPhone" value="${esc(session.phone)}"></div>
    <div class="field"><label>Address</label><input type="text" id="pfAddress" value="${esc(session.address || '')}" placeholder="123 Main St"></div>
    <div class="field-row">
      <div class="field"><label>City</label><input type="text" id="pfCity" value="${esc(session.city || '')}" placeholder="Orem"></div>
      <div class="field"><label>State</label>
        <select id="pfState">
          <option value="">—</option>
          ${US_STATES.map(st => `<option value="${st}" ${session.state === st ? 'selected' : ''}>${st}</option>`).join('')}
        </select>
      </div>
      <div class="field"><label>ZIP</label><input type="text" id="pfZip" inputmode="numeric" value="${esc(session.zip || '')}" placeholder="84057"></div>
    </div>
    <div style="display:flex;gap:10px;margin-top:14px">
      <button class="btn" id="saveParentBtn" style="flex:1">Save changes</button>
      <button class="btn-ghost" style="flex:1" onclick="closeModal()">Cancel</button>
    </div>`, true);
  document.getElementById('saveParentBtn').addEventListener('click', saveParent);
}
async function saveParent() {
  const email = document.getElementById('pfEmail').value.trim();
  const emailErr = document.getElementById('pfEmailErr');
  if (!isValidEmail(email)) {
    if (emailErr) emailErr.style.display = 'block';
    return;
  }
  if (emailErr) emailErr.style.display = 'none';
  try {
    const updated = await apiFetch('/accounts/' + session.id, {
      method: 'PUT',
      body: JSON.stringify({
        firstName: document.getElementById('pfFirst').value.trim() || session.firstName,
        lastName: document.getElementById('pfLast').value.trim() || session.lastName,
        email, phone: document.getElementById('pfPhone').value.trim(),
        address: document.getElementById('pfAddress').value.trim(),
        city: document.getElementById('pfCity').value.trim(),
        state: document.getElementById('pfState').value,
        zip: document.getElementById('pfZip').value.trim()
      })
    });
    Object.assign(session, {
      firstName: updated.firstName, lastName: updated.lastName, email: updated.email, phone: updated.phone,
      address: updated.address || '', city: updated.city || '', state: updated.state || '', zip: updated.zip || ''
    });
    document.getElementById('userName').textContent = session.firstName + ' ' + session.lastName;
    closeModal();
    refresh();
    toast('Contact details saved');
  } catch (e) { toastError(e.message); }
}
